export const API_RES_STATUS = {
    success: "success",
    error: "error",
    fail: "fail"
}